import * as React from 'react';
import { IDriveDocsProps } from './types';
import { CARD_CLASS } from '../../../../constants';
import './_DriveDocs.scss';
import { DriveDocHOC } from '../../hocs/DriveDocHOC/DriveDocHOC';
import { DRIVE_DOC_TITLE } from '../../../../wording';
import { AnalyzeRender } from '../../../../../../helpers/memoizeHelper';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`DriveDocs`) : null;

export function DriveDocs({
    mainDriveDocSet,
    cardId,
    isClone,
}: IDriveDocsProps) {
    if (analyzeRender) analyzeRender.call(cardId);
    const className = CARD_CLASS + '__drive-docs';

    return (
        <div className={`${CARD_CLASS + '__module'} ${className}`}>
            <div className={className + '-title'}>{DRIVE_DOC_TITLE}</div>
            {mainDriveDocSet.map((driveDoc) => {
                if (isClone) return <div key={driveDoc.id} className={className + '-fake-item'} />;
                return <DriveDocHOC driveDoc={driveDoc} key={driveDoc.id} />;
            })}
        </div>
    );
}
